import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { Header } from "@website/widget/login/components";
import { useNewPasswordCard } from "@website/widget/login/components/new-password-card/new-password-card.hook";
import styles from "@website/widget/login/components/new-password-card/new-password-card.module.scss";
import { NewPasswordCardPropertiesType } from "@website/widget/login/components/new-password-card/new-password-card.types";
import { PasswordField } from "@website/widget/password-field";
import { FC } from "react";

export const NewPasswordCard: FC<NewPasswordCardPropertiesType> = (
  properties
) => {
  const {
    error,
    password,
    onChangePassword,
    onSubmitPassword,
    isLoading,
    onCloseClick,
    onBackClick
  } = useNewPasswordCard(properties);

  return (
    <div className={styles["container"]}>
      <Header
        onBack={onBackClick}
        onClose={onCloseClick}
        title="رمز عبور جدید"
      />
      <form
        className="w-full"
        onSubmit={isLoading ? undefined : onSubmitPassword}
      >
        <div className={styles["title"]}>لطفاً یک رمز عبور جدید وارد کنید.</div>
        <div className={styles["input"]}>
          <PasswordField
            error={Boolean(error)}
            fullWidth
            helperText={error}
            initialValue={password}
            onChange={onChangePassword}
            placeholder="رمز عبور جدید"
          />
        </div>
        <div className={styles["footer"]}>
          <Button
            color="secondary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {isLoading ? <Loading color="white" size="lg" /> : "تایید و ادامه"}
          </Button>
        </div>
      </form>
    </div>
  );
};
